import styled from "styled-components";
export const NoticeWrapper = styled.section `
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background: #f5f7fb;

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;
export const NoticeCard = styled.div `
  width: 100%;
  max-width: 520px;
  padding: 40px 36px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid
    ${({ theme }) => { var _a; return `${((_a = theme === null || theme === void 0 ? void 0 : theme.colorPalette) === null || _a === void 0 ? void 0 : _a.primaryColor) || "#662d91"}20`; }};
  box-shadow: 0 24px 65px rgba(10, 13, 18, 0.08),
    0 12px 30px rgba(10, 13, 18, 0.05);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const IconRing = styled.span `
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin: 0 auto 8px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => { var _a; return `${((_a = theme === null || theme === void 0 ? void 0 : theme.colorPalette) === null || _a === void 0 ? void 0 : _a.secondaryColor) || "#4bc6b9"}1a`; }};
  color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.colorPalette) === null || _a === void 0 ? void 0 : _a.secondaryColor) || "#4bc6b9"; }};
`;
export const Heading = styled.h2 `
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.colorPalette) === null || _a === void 0 ? void 0 : _a.blackColor) || "#181d27"; }};
  letter-spacing: -0.4px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;
export const BodyText = styled.p `
  margin: 0;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.colorPalette) === null || _a === void 0 ? void 0 : _a.darkGray) || "#535862"; }};
`;
export const SubtleText = styled.p `
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.colorPalette) === null || _a === void 0 ? void 0 : _a.secondaryGrayColor) || "#6f7787"; }};
`;
